import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { formatGameTime } from "../format/formatGameTime";
import { formatList } from "../format/formatList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";

const TITLE = msg({
  id: "finding.lane_ganked",
  message: "Killed in lane by heroes from other lanes {count, plural, one {once} other {# times}}",
});

const DETAILS = msg({
  id: "finding.lane_ganked.details",
  message: "{deaths}. Watch the map: when an enemy disappears from their lane, back off.",
});

const DEATH = msg({ id: "finding.lane_ganked.death", message: "{time} — {hero}" });

// В фазе линий игрока убивали герои с других линий.
export const LaneGanked = ({ finding, variant }: FindingProps<"lane_ganked">) => {
  const { i18n } = useLingui();
  const findHero = useAssetLookup("heroes");
  const { deaths } = finding.params;
  const list = formatList(
    deaths.map((death) =>
      i18n._({
        ...DEATH,
        values: { time: formatGameTime(death.time_s), hero: findHero(death.killer_hero_id).name },
      }),
    ),
    i18n.locale,
  );
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<AssetIcon asset={findHero(deaths[0]?.killer_hero_id ?? 0)} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { count: deaths.length } })}
      details={i18n._({ ...DETAILS, values: { deaths: list } })}
      summary={list}
    />
  );
};
